module.exports = __webpack_public_path__ + "static/media/X.e6f92633.svg";